class ShovelDrawerSizing extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.attachOverlayClickListener();
  }

  handleVariantPickerClick(event) {
    const option = event.target.attributes["data-option-value-title"];
    const optionValue = option ? option.value : null;
    this.updateContent(optionValue);
  }

  attachOverlayClickListener() {
    this.querySelector('#ShovelDrawerSizing-Overlay').addEventListener('click', this.close.bind(this));
  }

  attachVariantPickerClickListener() {
    const variantPickerElement = document.getElementById('variant-selects-shovel-drawer-sizing');

    variantPickerElement.removeEventListener('click', this.handleVariantPickerClick.bind(this));

    variantPickerElement.addEventListener("click", this.handleVariantPickerClick.bind(this), {
      once: false,
      passive: true,
      bubble: false,
    });
  }

  attachUnitToggleListeners() {
    const sizeGuide = this.querySelector('#size-guide');
    if (!sizeGuide) return;

    sizeGuide.querySelectorAll('input[name="unit"]').forEach((radio) => {
      radio.addEventListener('change', (event) => {
        const parentDiv = this.querySelector('#size-guide');
        if (event.target.value === 'cm') {
          parentDiv.classList.remove('unit-in');
          parentDiv.classList.add('unit-cm');
        } else {
          parentDiv.classList.remove('unit-cm');
          parentDiv.classList.add('unit-in');
        }
      });
    });
  }

  setFocusOnDrawer() {
    const sizeDrawer = document.querySelector("#ShovelDrawerSizing-Inner");
    // I do not know why, but a timeout is required for focus to work...
    setTimeout(() => {
      trapFocus(sizeDrawer);
    }, 50);
  }

  open() {
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    this.setFocusOnDrawer();

    this.attachVariantPickerClickListener();
    this.attachUnitToggleListeners();
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');

    const sizeDrawer = document.querySelector("#ShovelDrawerSizing-Inner")
    removeTrapFocus(sizeDrawer);
  }

  getProductData() {
    const productData = JSON.parse(document.getElementById('ProductJson').textContent);
    return productData;
  }

  updateContent(optionValue) {
    const productData = this.getProductData();
    // find the variant by the option value from the product-variant-picker
    const variant = productData.variants.find(variant => variant.title == optionValue);

    if (!variant) {
      return;
    }

    const sectionId = 'shovel-drawer-sizing';
    const request = new XMLHttpRequest();
    request.addEventListener('load', handleResponse.bind(this));
    request.open('GET', `${window.location.pathname}/?variant=${variant.id}&sections=${sectionId}`, true);
    request.send();

    function handleResponse() {
      if (request.status === 200) {
        const response = JSON.parse(request.responseText);
        const sectionHtml = response[sectionId];

        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHtml, "text/html");

        const shovelDrawerContainer = doc.querySelector(sectionId);
        const containerHtml = shovelDrawerContainer ? shovelDrawerContainer.innerHTML : null;

        const section = document.querySelector(sectionId);

        if (section && containerHtml) {

          section.innerHTML = '';
          section.innerHTML = containerHtml;

          // Debugging: Check if the script tag has the expected data
          const scriptTag = section.querySelector('#ProductJson');
          if (scriptTag) {
            console.log('Script Data:', JSON.parse(scriptTag.textContent || '{}'));
          }
        }
        // We need to re-attach the event listeners after a new render
        this.attachOverlayClickListener();
        this.attachVariantPickerClickListener();
        this.attachUnitToggleListeners();
        this.setFocusOnDrawer();

      } else {
        console.error('Error fetching section:', request.status);
      }
    }
  }
}

customElements.define('shovel-drawer-sizing', ShovelDrawerSizing);
